var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wl-custom-form"},[_c('fc-designer',{ref:"designer",attrs:{"menu":_vm.menu}},[_c('template',{slot:"handle"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.fanhui}},[_vm._v("返回")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.getForm}},[_vm._v("保存设计")])],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }